module.exports = __webpack_public_path__ + "img/unsplash_jpHw8ndwJ_Q.2b4e4fe9.png";